// extracted by mini-css-extract-plugin
module.exports = {"embedCamOfflineWrapper":"EmbedCamOffline__embedCamOfflineWrapper__3QlZz","perfPicture":"EmbedCamOffline__perfPicture__2ZX5T","logoPicture":"EmbedCamOffline__logoPicture__W13-5"};